// extracted by mini-css-extract-plugin
export var button = "filmsCards-module--button--17c5f";
export var cafeFormIntro = "filmsCards-module--cafe-form-intro--93d88";
export var card = "filmsCards-module--card--a78a0";
export var cardContainer = "filmsCards-module--card-container--a3cfe";
export var cardWrapper = "filmsCards-module--card-wrapper--3a231";
export var highlight = "filmsCards-module--highlight--77ca0";
export var redButton = "filmsCards-module--red-button--ec36f";
export var redTransparentButton = "filmsCards-module--red-transparent-button--5f457";
export var title = "filmsCards-module--title--74202";
export var transparentButton = "filmsCards-module--transparent-button--748d5";